"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.eventFactory = Factory.Sync.makeFactory({
    _links: [],
    all_day_event: true,
    allow_rsvp: true,
    created_at: Mocks.dates.date2000,
    description: 'Test Event',
    end_date_time: Mocks.dates.date2100,
    event_attendees: [],
    event_type: 'event',
    game_details: {},
    id: Factory.each(() => uuid_1.v4()),
    local_timezone: 'America/Chicago',
    location: '',
    location_address: '1234 Main St, Minneapolis, MN, United States (Field A1)',
    location_description: '',
    location_place_id: 1,
    location_url: '',
    org_id: 26369,
    originator_id: '12345678_2000-01-01',
    originator_system: 'Ngin',
    originator_type: 'event',
    principals: [],
    sport_key: '',
    start_date_time: Mocks.dates.date2000,
    status: 'Scheduled',
    tbd_time: false,
    title: 'Super Bowling Bonanza',
    updated_at: Mocks.dates.date2100,
    venue_id: null,
    venue_url: ''
});
